'use client';

import { Toaster } from '@/components/ui/sonner';
export function ToasterProvider() {
  return <Toaster data-sentry-element="Toaster" data-sentry-component="ToasterProvider" data-sentry-source-file="toaster-provider.tsx" />;
}